import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c1862d7c&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/hens-nv/src/vue-apps/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1862d7c')) {
      api.createRecord('c1862d7c', component.options)
    } else {
      api.reload('c1862d7c', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=c1862d7c&", function () {
      api.rerender('c1862d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/App.vue"
export default component.exports